<template>
  <div class="language-switcher">
    <FontIcon name="ui_language" />
    <SelectInput
      id="input--language-switcher"
      :class="`language-select language-${locale}`"
      label=""
      :options="options"
      :value="locale"
      @update:value="$emit('update:locale', $event)"
    />
  </div>
</template>

<style lang="scss">
.language-switcher {
  position: relative;
  max-width: 100%;
  position: relative;
  @include setColor(--color-text);

  .font-icon {
    position: absolute;
    left: rem(15px);
    top: 50%;
    transform: translateY(-50%);
    font-size: rem(22px);
    @include setColor(--color-icon1);
  }

  .language-select {
    position: relative;

    select {
      padding-left: rem(45px);
      padding-bottom: rem(15px);
      option {
        @include setColor(--color-background1, background-color, true);

        @include respond-min("xlarge") {
          @include setColor(--color-background4, background-color, true);
        }
      }
    }

    &::after {
      display: block;
      content: "";
      height: rem(14px);
      width: rem(20px);
      position: absolute;
      top: rem(20px);
      left: rem(15px);
      background-size: rem(20px 20px);
      pointer-events: none;
      background-position: 50% 50%;
    }
  }
}
</style>

<script>
import FontIcon from "../FontIcon";
import SelectInput from "../inputs/SelectInput";

export default {
  name: "LanguageSwitcher",

  components: {
    FontIcon,
    SelectInput,
  },

  props: {
    options: {
      type: Array,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    },
  },
};
</script>
